import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'development',
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
  beforeSend(event) {
    // 환자 포털: URL에서 survey token 제거
    if (event.request?.url) {
      event.request.url = event.request.url.replace(/\/s\/[^/?#]+/, '/s/[token]');
    }
    return event;
  },
});
